import { PageLayout } from '@kizi/comparator-core';
import addressWithWizardContext from '../widgets/Address/addressWithWizardContext';
import osTriplePlayProviderOptions from '../content/osTriplePlayProviderOptions';

const startWidgetLayout: PageLayout = {
  name: 'startWidget',
  components: [
    {
      type: 'StartWidget',
      props: {
        badgeContent: {
          type: 'WidgetBadge',
          props: {
            label: 'Cashback',
            tooltip:
              'Klik <a href="https://www.overstappen.nl/internet/cashback" target="_blank">hier</a> voor meer informatie over cashbackacties en hoe je deze kunt claimen.',
          },
        },
        direction: 'vertical',
        title: 'Internet vergelijken',
        buttonProps: {
          children: 'Vergelijk pakketten',
        },
        nextStepIndex: 1,
        nextStepName: 'startWidget',
        fieldNames: [
          'startWidget.postcode',
          'startWidget.housenumber',
          'startWidget.housenumberaddition',
          'startWidget.city',
          'startWidget.street',
          'startWidget.fullAddress',
          'overview.productTypes',
          'startWidget.currentProvider',
          'overview.filters',
          'overview.defaultFilters',
          'overview.defaultFilters',
          'overview.filterGraphQL',
        ],
        registerInAnalytics: true,
        analyticsName: 'TriplePlay',
      },
      _children: [
        addressWithWizardContext,
        {
          type: 'Div',
          props: {
            variant: 'widget',
            mt: 5,
          },
          _children: [
            {
              type: 'FormInput',
              props: {
                name: 'currentProvider',
                component: {
                  type: 'Inputs.Select',
                  props: {
                    _label: 'Je huidige provider',
                    _tooltip:
                      'Selecteer je huidige provider om tot de beste deals te komen',
                    options: osTriplePlayProviderOptions,
                    optionsFieldName: 'startWidget.providerOptions',
                  },
                },
              },
            },
          ],
        },
        {
          type: 'Div',
          props: {
            variant: 'widget',
          },
          _children: [
            {
              type: 'PackageCheckbox',
              props: {
                label: 'Pakket',
                name: 'productTypes',
                _fieldName: 'overview.productTypes',
                _containerProps: { mt: 5 },
              },
            },
          ],
        },
        {
          type: 'FormSubmit',
          props: {
            children: 'Check je besparing',
            variant: 'primary',
          },
        },
      ],
    },
  ],
};

export default startWidgetLayout;
